/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ui_Import_Summary_FailedInputs */

const en_ui_import_summary_failed = /** @type {(inputs: Ui_Import_Summary_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} failed`)
};

const de_ui_import_summary_failed = /** @type {(inputs: Ui_Import_Summary_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "{count} failed" |
*
* @param {Ui_Import_Summary_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_import_summary_failed = /** @type {((inputs: Ui_Import_Summary_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Import_Summary_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_import_summary_failed(inputs)
	return de_ui_import_summary_failed(inputs)
});